import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { Button } from 'src/shared/components/ui/button'
import {
  SALES_APPROVED_QUOTE_STATUS,
  effectiveQuoteStatus,
  isAwaitingKlayderReview,
  isPreSalesApprovalStatus,
} from 'src/shared/consts/quoteStatus'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { useRequestContext } from '../../hooks/RequestContext'

/** Soft nudge on Explore: draft is ready → open Checkout (approval happens there). */
export const ReadyToCheckoutCta = ({
  hasItems,
  onGoToCheckout,
}: {
  hasItems: boolean
  onGoToCheckout: () => void
}) => {
  const { t } = useLocalization()
  const { quote } = useRequestContext()

  const status = effectiveQuoteStatus(quote?.status)
  const showCta =
    hasItems &&
    quote?.id != null &&
    (isPreSalesApprovalStatus(status) ||
      status === SALES_APPROVED_QUOTE_STATUS)

  if (!showCta) return null

  const readyForCustomer = status === SALES_APPROVED_QUOTE_STATUS

  return (
    <div className="pointer-events-none absolute top-3 left-1/2 z-40 -translate-x-1/2">
      <motion.div
        className="pointer-events-auto"
        initial={{ y: -12, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.25, ease: 'easeOut' }}
      >
        <Button
          variant="glass"
          size="sm"
          className="heartbeat-border-3 shadow-lg"
          onClick={onGoToCheckout}
        >
          {readyForCustomer
            ? t(
                'Quote ready — go to checkout',
                'Offert klar — gå till kassan'
              )
            : isAwaitingKlayderReview(status)
              ? t(
                  'Waiting for Klayder — see checkout',
                  'Väntar på Klayder — se kassan'
                )
              : t(
                  'Ready to order? Go to checkout',
                  'Redo att beställa? Gå till kassan'
                )}
          <ArrowRight className="ml-1.5 h-3.5 w-3.5 opacity-60" />
        </Button>
      </motion.div>
    </div>
  )
}
